// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"acf28687","453":"9ac8bd8c"}[chunkId] + ".chunk.js";
};